<template>
    <div class="related-content">
        <TheGuidelinesLayout class="guideline-layout--narrow">
            <template #sidebar>
                <BaseGuidelineChapters
                    v-if="(chapters && chapters.length) || pending"
                    class="guideline-chapters"
                    :chapters="chapters ? chapters : null"
                    :numeric="false"
                    :pending="pending"
                    :apply-title-case="false"
                />
            </template>

            <h2>Related content</h2>

            <template v-if="relatedContent">
                <!-- eslint-disable vue/no-v-html -->
                <div
                    v-if="relatedContent.introText"
                    class="lead"
                    data-allow-anchor
                    v-html="relatedContent.introText"
                />
                <!-- eslint-enable vue/no-v-html -->

                <FlexibleSections
                    :sections="relatedContent ? relatedContent.guidelinesRelatedContent : []"
                    :placeholder="pending ? 'content' : undefined"
                />
            </template>
        </TheGuidelinesLayout>
    </div>
</template>

<script setup>
import {kebabCase} from 'lodash-es';
import RelatedContentQuery from '~/graphql/queries/guidelines/related-content.graphql';

const props = defineProps({
    guideline: {
        required: true,
        type: Object,
        default: null
    }
});

const response = await useLazyAsyncQuery({
    query: RelatedContentQuery,
    variables: {
        id: Number(props.guideline?.id)
    }
});

const { data, pending } = response;

const relatedContent = computed(() => {
    return data?.value?.entry;
});

const guidelinesRelatedContent = computed(() => {
    return relatedContent?.value?.guidelinesRelatedContent;
});

const chapters = computed(() => {
    if (props.guideline && guidelinesRelatedContent.value) {
        return guidelinesRelatedContent.value.map((item) => {
            return {
                title: item.title,
                uri: `#${kebabCase(item.title)}`,
                isAnchor: true
            };
        });
    }

    return null;
});
</script>

<style lang="less">
.related-content {
    .lead, p {
        .typography-small();

        margin-top: var(--spacing-lg);
    }

    .empty, p {
        .typography-text();
    }

    .guideline-chapters .guideline-chapters__item {
        &:hover, &:active, &:focus {
            color: var(--color-primary);
        }
    }
}
</style>
